import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Text from '../../Text/Text';
import { IconCheckbox } from '../../../assets/icon';
import { setCreateNewOrderStep } from '../../../thunks/coilovers/orders/createNewOrder';

const StepperItem = ({
 count, title, subTitle, active, checked, id
}) => {
  const dispatch = useDispatch();
  const {
    createNewOrderData: {
      width,
      height,
      length,
      weight,
      address,
      firstName,
      lastName,
      country,
      state: orderState,
      city,
      zip,
      phone,
    },
    getOrderByPo: {
      orderData
    }
  } = useSelector((state) => ({
    createNewOrderData: state.createNewOrder?.data,
    getOrderByPo: state.getOrderByPo
  }), shallowEqual);

  const checkIfError = () => {
    if (id === 'shipping') {
      return !!(orderData?.order_id
        && (!width || !height || !length || !weight));
    }
    if (id === 'client') {
      return !address || !firstName || !lastName || !country || !orderState || !city || !zip || !phone;
    }
    return false;
  };

  const isError = checkIfError();

  return (
    <div
      role="presentation"
      onClick={() => dispatch(setCreateNewOrderStep(id))}
      className={`flex flex-row mb-[40px] cursor-pointer last:mb-0
      ${checked ? 'opacity-50' : ''}
      ${isError ? 'text-danger' : ''}`}
    >
      <div
        className={`flex justify-center items-center w-[40px] h-[40px] rounded-[12px] mr-[20px]
        bg-[#f1faff] text-[#3E97FF] text-[16px] font-medium border-[4px] border-white
        ${active ? 'bg-[#3E97FF] text-white' : ''}`}
      >
        {checked ? <IconCheckbox /> : count}
      </div>
      <div className="flex flex-col">
        <Text textStyle={`text-[16px] ${isError ? 'text-danger' : 'text-[#252F4A]'}`} text={title} />
        {subTitle && (
          <Text textStyle={`text-[13px] ${isError ? 'text-danger' : 'text-[#99A1B7]'}`} text={subTitle} />
        )}
      </div>
    </div>
  );
};

StepperItem.propTypes = {
  count: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  id: PropTypes.string.isRequired,
  active: PropTypes.bool,
  checked: PropTypes.bool,
};

StepperItem.defaultProps = {
  subTitle: '',
  active: false,
  checked: false,
};

export default StepperItem;
